import LoginPage from './Login';
import enhance from './LoginPage.enhancer';
export default enhance(LoginPage);
